import Text from "components/atoms/Text";
import FilterProduct from "components/molecules/FilterProduct";
import Sort from "components/molecules/Sort";
import React, { ChangeEvent } from "react";
import { joinClassnames } from "utils/map-modifier";
import Section from "../Section";
import "./index.scss";

interface ProductSortResultProps {
  filters: FilterProps;
  count: number;
  total: number;
  isShowSortFilter?: boolean;
  handleChange?: (e: ChangeEvent<HTMLInputElement>) => void;
  handleRemoveFilter: (key: KeyFilter, title?: string) => void;
  handleRemoveAllFilter: () => void;
}

const ProductSortResult: React.FC<ProductSortResultProps> = ({
  filters,
  count,
  total,
  isShowSortFilter,
  handleChange,
  handleRemoveFilter,
  handleRemoveAllFilter,
}) => {
  const bindHTMLFilter = (filters: FilterProps) => {
    const x = Object.entries(filters).map(([key, obj]) => {
      switch (key) {
        case "ROOM":
        case "LOAI_MAY":
        case "CONG_NGHE_INVERTER":
        case "subcategory":
        case "CONG_SUAT_LANH_SA":
        case "DIEN_NGUON":
        case "CONG_SUAT_LAM_LANH":
        case "PRICE": {
          const { selected } = obj as {
            selected: CheckboxField[];
            value: string;
          };

          return selected.map(({ title }) => (
            <FilterProduct.Item key={title}>
              <FilterProduct.Title>
                <span>{title}</span>
                <span
                  className="a-remove"
                  onClick={() =>
                    selected.length > 1
                      ? handleRemoveFilter(key, title)
                      : handleRemoveFilter(key)
                  }
                >
                  x
                </span>
              </FilterProduct.Title>
            </FilterProduct.Item>
          ));
        }

        case "CAN_BANG_DO_AM_THONG_MINH":
        case "LUONG_GIO_3_CHIEU":
        case "TIET_KIEM_NANG_LUONG":
        case "LAM_LANH_NHANH":
        case "TINH_LOC_KHONG_KHI":
        case "LUONG_GIO_COANDA":
        case "CHUC_NANG_CHONG_AM_MOC":
        case "DO_BEN_CAO":
        case "DIEU_KHIEN_TIEN_NGHI": {
          const { title } = obj as { title: string; checked: boolean };
          return (
            <FilterProduct.Item>
              <FilterProduct.Title>
                <span>{title}</span>
                <span
                  className="a-remove"
                  onClick={() => handleRemoveFilter(key, title)}
                >
                  x
                </span>
              </FilterProduct.Title>
            </FilterProduct.Item>
          );
        }
        default:
          break;
      }
      return null;
    });

    return x;
  };

  const checkPassKeys = (ob: Object, ar: string[]) => {
    let pass = true;
    Object.keys(ob).forEach(obk => {
      if (ar.indexOf(obk) === -1) pass = false;
    });
    return pass;
  };

  return (
    <Section modifiers={["nopadding"]}>
      {filters.slug !== "sky-air" && isShowSortFilter && (
        <div className={joinClassnames("o-product-sort-result-top")}>
          <Sort sort={filters.SORT} handleChange={handleChange} />
        </div>
      )}
      <div className={joinClassnames("o-product-sort-result-bottom")}>
        <Text size="sm" modifiers={["grey"]}>
          Có {count}/{total} Sản Phẩm
        </Text>
        {(filters.slug === "loai-2-dan-roi" || filters.slug === "sky-air") &&
          !checkPassKeys(filters, ["pageSize", "pageNum", "slug", "SORT"]) && (
            <FilterProduct>
              {filters && bindHTMLFilter(filters)}
              {filters && (
                <FilterProduct.Item modifiers={["remove"]}>
                  <FilterProduct.Title>
                    <span>Xóa bộ lọc</span>{" "}
                    <span className="a-remove" onClick={handleRemoveAllFilter}>
                      x
                    </span>
                  </FilterProduct.Title>
                </FilterProduct.Item>
              )}
            </FilterProduct>
          )}
      </div>
    </Section>
  );
};

ProductSortResult.defaultProps = {};

export default ProductSortResult;
